import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { MarginProps, styledMargin } from '../Margins/margins';

type SkeletonLineLoaderProps = {
  width: string;
  height: string;
  inline?: boolean;
} & MarginProps;

const shine = () => {
  return keyframes`
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: calc(100% + 300px);
  }
`;
};

const StyledSkeletonLineLoader = styled.div<SkeletonLineLoaderProps>`
  opacity: 0.4;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: #f4f4f4;
  border-radius: 8px;
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgba(229, 229, 229, 0.8) 40px,
    #f4f4f4 80px
  );
  background-size: 300px;
  background-repeat: no-repeat;
  animation: ${shine} 1.6s infinite ease-out;
  ${(props) =>
    props.inline &&
    css`
      display: inline-block;
    `}
  ${styledMargin}
`;

export const SkeletonLineLoader = ({
  width,
  height,
  mb,
  inline,
  ...rest
}: SkeletonLineLoaderProps) => {
  return (
    <StyledSkeletonLineLoader width={width} height={height} mb={mb} inline={inline} {...rest} />
  );
};
